export default __webpack_public_path__ + "static/940-2f4fd807477d5f553e0c799586a105bb.gif";